import script from "./DatePickerInput.vue?vue&type=script&setup=true&lang=js"
export * from "./DatePickerInput.vue?vue&type=script&setup=true&lang=js"

import "./DatePickerInput.vue?vue&type=style&index=0&id=24769fe0&lang=scss&scoped=true"

import exportComponent from "/media/dolar/office/office_project/barmm-admin-portal/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-24769fe0"]])

export default __exports__